import { twJoin } from 'tailwind-merge';
import { useTranslation } from 'react-i18next';
import { InformationCircleIcon } from '@heroicons/react/24/outline';

import PillComponent from '@/components/ui/custom/dataDisplay/PillComponent';
import Text from '@/components/ui/custom/dataDisplay/Text';
import Popup from '@/components/ui/custom/Popup';
import { ManageScheduledLessonState } from './ManageScheduledLesson';

type AttendancePillProps = {
  presences: number;
  absences: number;
  studentsCount: number;
  state?: ManageScheduledLessonState;
};

export function AttendancePill({
  presences,
  absences,
  studentsCount,
  state = 'manager',
}: AttendancePillProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'calendar.admin.manageKlass',
  });

  const attendance = [
    {
      title: t('manageAttendance.attendances'),
      total: presences,
    },
    {
      title: t('manageAttendance.absences'),
      total: absences,
    },
  ];

  return (
    <PillComponent
      className={twJoin('w-fit flex-wrap', state === 'manager' && 'px-2 py-1')}
    >
      <div className="flex content-center items-center align-middle gap-1">
        <Text text={t('attendance')} format="rubik-500" />
        <Text
          text={presences + ' / ' + studentsCount}
          format="rubik-400"
          className="text-base-content self-center"
        />
      </div>
      <Popup
        hover
        className={{ popup: 'z-10' }}
        reference={
          <InformationCircleIcon className="w-4 h-4 text-primary cursor-pointer" />
        }
      >
        <div className="flex flex-col gap-1 bg-base-100 rounded-xl p-2 border border-neutral-content shadow-default">
          {attendance.map(({ title, total }) => (
            <div className="flex gap-3" key={title}>
              <Text text={title} format="rubik-500" className="text-primary" />
              <Text text={total.toString()} format="rubik-400" />
            </div>
          ))}
        </div>
      </Popup>
    </PillComponent>
  );
}
